var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.eventsLastVisible.noMore)?_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.loadEvents(_vm.eventsLastVisible)}}},[_c('v-icon',[_vm._v(" mdi-chevron-down ")]),_vm._v(" Cargar más ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }